import { Icon } from '../../common/Icon';
import { TabItem } from '../../common/Tabs';

import { CheckInTypeEnum } from './types/types';

export const initialCheckInData = {
  type: CheckInTypeEnum.TICKET,
  ticketId: undefined as string | undefined,
  title: '',
  description: '',
  hasBlockers: false,
  blockers: '',
  wipMaterials: '',
  prevProgress: 0,
  progress: 0,
  isUpdate: false,
};

export const getTabItems = (checkInTimes: string[] = []): TabItem[] => [
  {
    name: 'Mid-Day',
    icon: ({ selected }: { selected: boolean }) => (
      <Icon
        name="sun"
        className={selected ? 'text-primary' : 'text-disabled'}
      />
    ),
    subText: checkInTimes[0] || '--:--',
  },
  {
    name: 'Day-End',
    icon: ({ selected }: { selected: boolean }) => (
      <Icon
        name="sunset"
        className={selected ? 'text-primary' : 'text-disabled'}
      />
    ),
    subText: checkInTimes[1] || '--:--',
  },
];

export const MAX_VALIDATION_ATTEMPTS = 2;
